<div class="mct-flex mct-col mct-gap-27"  >
  <div>
    {{ 'reports.query-tool.select-fields.choose-a-data-group' | translate | titlecase }}
    <p-select
      [options]="availableViews"
      placeholder="{{ 'common.select' | translate }}"
      [(ngModel)]="queryDefinition.ViewName"
      styleClass="w-100"
      [style]="{ 'min-width': '0', height: '36px' }"
      required
      (onChange)="viewChanged($event.value)"
    >
    </p-select>
  </div>
  <div>
    <label>{{ 'reports.query-tool.select-fields.select-the-fields' | translate | titlecase }}</label>
  </div>
  <div    class="selector-container mct-flex mct-row mct-justify-between mct-items-center mct-gap-27">
    <div class="field-selector-grid mct-flex mct-col mct-flex-1-1-0"  >
      <div class="field-header pl-27 pt-9 pb-9">
        <strong>{{ 'reports.query-tool.select-fields.fields' | translate | titlecase }}</strong>
      </div>
      <div class="scroll-y mct-flex-1-1-0" >
        <div class="field-container" *ngFor="let field of availableFields">
          <div class="field-row mct-flex mct-row mct-justify-between mct-items-center"  >
            <div class="ml-27 mt-9 mb-9">
              {{ field.ReplacementName }}
            </div>
            <div class="mr-27">
              <button pButton type="button" [disabled]="field.Selected" [class]="field.Selected ? 'added-button' : 'add-button'" (click)="addField(field)">
                <span [hidden]="field.Selected">
                  {{ 'common.add' | translate | titlecase }}
                  <span class="pi pi-arrow-right"></span>
                </span>
                <span [hidden]="!field.Selected">
                  {{ 'reports.query-tool.select-fields.added' | translate | titlecase }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div cdkDropList (cdkDropListDropped)="sorted($event)" class="field-selector-grid mct-flex mct-col mct-flex-1-1-0"  >
      <div class="field-header mct-grid query-fields-grid-2col" >
        <div class="right-border"></div>
        <div class="ml-27 mt-9 mb-9">
          <strong> {{ 'reports.query-tool.select-fields.columns' | translate | titlecase }}</strong>
        </div>
      </div>
      <div class="scroll-y">
        <div cdkDrag class="field-container" *ngFor="let field of selectedColumns">
          <div class="field-row mct-grid query-fields-grid-3col" >
            <div class="wc-movable right-border">
              <span class="grip">&nbsp;</span>
            </div>
            <div class="ml-27 mt-9 mb-9">
              {{ field.ReplacementName }}
            </div>
            <div class="mr-27 mt-2 mct-grid mct-place-center">
              <button pButton type="button" class="add-button" (click)="removeField(field)">
                <span class="pi pi-arrow-left"></span> {{ 'common.remove' | translate | titlecase }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
